<template>
  <div>
    <div class="checkbox-list">
      <div
        v-for="(item, itemIndex) in proxyArray"
        :key="item.id"
        class="checkbox-item"
      >
        <FormInputCheckbox
          v-model="item.isSelected"
          :id="item.id"
          :label="item.title"
        />
        <div class="checkup-stats">
          <div
            v-for="(group, groupId) in groupsItemsCount[itemIndex]"
            :key="groupId"
            class="checkup-stats__item"
            @click="
              $emit(
                'openProgramGroupsInfo',
                'open',
                `${group.length} ${getPluralTitle(groupId, group.length)}`,
                group
              )
            "
          >
            {{ group.length }} {{ getPluralTitle(groupId, group.length) }}
          </div>
        </div>
        <img
          v-if="item.image"
          class="check-up__image"
          :src="item.image"
          alt=""
          @click="item.isSelected = !item.isSelected"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from 'vue'
import FormInputCheckbox from './FormInputCheckbox.vue'
import { pluralize } from '@/views/programs/checkup/utils/pluralize.js'

export default {
  name: 'RegularCheckboxList',
  emits: ['updateSelectedPrograms', 'openProgramGroupsInfo'],
  components: { FormInputCheckbox },
  props: {
    modelValue: {
      type: [Array || null],
      default: null,
      required: true
    },
    programsSetup: {
      type: [Array || null],
      default: null,
      required: true
    }
  },
  setup (props, { emit }) {
    const proxyArray = ref(props.modelValue)

    watch(
      proxyArray,
      () => {
        emit('updateSelectedPrograms', proxyArray.value)
      },
      { deep: true }
    )

    const groupsItemsCount = computed(() => {
      return proxyArray.value.map((checkup) => {
        return checkup.items.reduce((acc, item) => {
          if (!acc[item.group_id]) {
            acc[item.group_id] = []
          }
          acc[item.group_id].push(item)
          return acc
        }, {})
      })
    })

    function getPluralTitle (groupId, count) {
      const group = props.programsSetup.group_id.find(
        (group) => group.value === +groupId
      )
      return group.plural[pluralize(count)]
    }

    return {
      proxyArray,
      groupsItemsCount,
      getPluralTitle
    }
  }
}
</script>

<style scoped>
.checkbox-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

@media (max-width: 768px) {
  .checkbox-list {
    grid-template-columns: auto;
    gap: 8px;
  }
}

.checkbox-item {
  display: grid;
  grid-template-rows: auto auto 1fr;
  padding: 15px 10px;
  border: 1px solid #7f8da9;
  border-radius: 4px;
}
.checkup-stats {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.checkup-stats__item {
  display: grid;
  place-content: center;
  background: #e1e8f4;
  border-radius: 100px;
  font-weight: 400;
  font-style: Regular;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  font-size: 12px;
  height: 28px;
  padding: 0 16px;
  color: #002856;
  cursor: pointer;
}

@media (max-width: 575px) {
  .checkup-stats__item {
    font-size: 10px;
  }
}

.check-up__image {
  width: 100%;
  margin-top: 10px;
  max-height: 330px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  align-self: end;
}
</style>
